import Vue from 'vue'
export default () => {
  const state = Vue.observable({
    params: {
      contact: {
        enable: false,
        id: 201
      },
      bank: {
        enable: false,
        id: 202
      },
      identifies: {
        enable: false,
        id: 203
      },
      address: {
        enable: false,
        id: 204
      }
    },
    post: [],
    delete: [],
    idfolder:'',
    idtypedocument:''
  })
  const setParams = (prop, obj) => {
    state.params[prop] = { ...state.params[prop], ...obj }
    if (obj.enable && !state.post.includes(state.params[prop].id)) {
      state.post.push(state.params[prop].id)
    } else {
      state.post = state.post.filter((id) => id !== state.params[prop].id)
    }
    state.idfolder = obj.idfolder !== undefined ? obj.idfolder : state.idfolder;
    state.idtypedocument = obj.idtypedocument !== undefined ? obj.idtypedocument : state.idtypedocument;
    if (!obj.enable && !state.post.includes(state.params[prop].id) && obj.enable !== undefined) {
      state.delete.push(state.params[prop].id)
    } else {
      state.delete = state.delete.filter((id) => id !== state.params[prop].id)
    }
  }
  const resetParams = () => {
    Object.keys(state.params).forEach((key) => { state.params[key].enable = false })
    state.post = []
    state.delete = []
    state.idfolder = ''
    state.idtypedocument = ''
  }

  const updateParams = (prop, obj) => {
    state.params[prop] = { ...state.params[prop], ...obj }
  }

  return {
    state,
    resetParams,
    setParams,
    updateParams
  }
}
